import React from 'react'
import PropTypes from 'prop-types'
import Select from '../../../form/component/Select'

const RELATION_SHIP = [
    {
        id: 'I',
        value: 'I',
    },
    {
        id: 'II',
        value: 'II',
    },
    {
        id: 'III',
        value: 'III',
    },
]

const RelationShip = ({ existingCondition, title, changeExistingCondition, leftValue, rightValue, readOnly, saveTreatmentPlan }) => {
    const onChange = (name, value) => {
        changeExistingCondition(name, value)
        saveTreatmentPlan()
    }
    return (
        <div>
            <b>{title}</b>
            <div className="relation-ship-row">
                <div className="relation-ship-text">
                    right class
                </div>
                <div className="relation-ship-select">
                    <Select
                        object={existingCondition}
                        name={rightValue}
                        onChange={onChange}
                        readOnly={readOnly}
                        valueList={RELATION_SHIP}/>
                </div>
            </div>
            <div className="relation-ship-row">
                <div className="relation-ship-text">
                    left class
                </div>
                <div className="relation-ship-select">
                    <Select
                        object={existingCondition}
                        name={leftValue}
                        onChange={onChange}
                        readOnly={readOnly}
                        valueList={RELATION_SHIP}/>
                </div>
            </div>
        </div>)
}

RelationShip.propTypes = {
    existingCondition: PropTypes.object.isRequired,
    title: PropTypes.string.isRequired,
    changeExistingCondition: PropTypes.func.isRequired,
    leftValue: PropTypes.string.isRequired,
    rightValue: PropTypes.string.isRequired,
    readOnly: PropTypes.bool.isRequired,
    saveTreatmentPlan: PropTypes.func.isRequired,
}

export default RelationShip



// WEBPACK FOOTER //
// ./src/modules/treatment/component/plan/RelationShip.js